enum EnumJobStatus {
	Disabled = 0,
	Wait = 1,
	Queued = 2,
	Preparing = 3,
	RunWaiting = 4,
	Running = 5,
	Success = 6,
	Failed = 7,
	Removed = 8
}
export default EnumJobStatus
